// extracted by mini-css-extract-plugin
export default {"editHeaderArea":"HeadTitleTable_editHeaderArea__rFJoX","indexTitle":"HeadTitleTable_indexTitle__edmCw"};